import { render } from "./HeroiconsSolidCloud.vue?vue&type=template&id=6d2a5f1e"
const script = {}

import exportComponent from "/Users/thuanluu/code/owlx/more9_venues/package/private/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCloud.vue"]])

export default __exports__